// 养老接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';
import { filterObjWithValidValue } from '@/api/url';

const {baseApi} = apiPrefix;

// monitor菜单配置 - 列表
export function getMonitorMenuList(params){
  return get(baseApi + '/monitorMenu/list', params);
}
// monitor菜单配置 - 新增、修改
export function monitorMenuAddOrUpdate(params){
  if (params.id > 0) return post(baseApi + "/monitorMenu/update", params);
  return post(baseApi + "/monitorMenu/add", params);
}
// monitor菜单配置 - 删除
export function monitorMenuDelete(params){
  return get(baseApi + "/monitorMenu/delete", params);
}




// monitor报表配置 - 列表
export function getMonitorReportList(params){
  return get(baseApi + '/monitorReport/list', params);
}
// monitor报表配置 - 新增、修改
export function monitorReportAddOrUpdate(params){
  return post(baseApi + "/monitorReport/save", params);
}
// monitor报表配置 - 删除
export function monitorReportDelete(params){
  return get(baseApi + "/monitorReport/delete", params);
}



// monitor表头配置 - 列表
export function getMonitorTheadList(params){
  return post(baseApi + '/monitorThead/list', params);
}
// monitor表头配置 - 新增、修改
export function monitorTheadAddOrUpdate(params){
  return post(baseApi + "/monitorThead/save", params, {noValid: true});
}
// monitor表头配置 - 删除
export function monitorTheadDelete(params){
  return get(baseApi + "/monitorThead/delete", params);
}



// monitor角色配置 - 智保云菜单选项
// export function getMonitorRoleZbyMenuOptions(params){
//   return get(baseApi + '/menu/list', params); //type 1 树状结构； type 2 次级一维数组
// }
// monitor角色配置 - 列表
export function getMonitorRoleList(params){
  return post(baseApi + '/monitorRole/list', params);
}
// monitor角色配置 - 新增、修改
export function monitorRoleAddOrUpdate(params){
  return post(baseApi + "/monitorRole/save", params);
}
// monitor角色配置 - 删除
export function monitorRoleDelete(params){
  return get(baseApi + "/monitorRole/delete", params);
}



// 角色配置 - 列表
export function getRoleList(params){
  return get(baseApi + '/user/getRoleList', params);
}



// 用户配置 - 列表
export function getUserList(params){
  return post(baseApi + '/user/list', params);
}
// 用户配置 - 新增、修改
export function userAddOrUpdate(params){
  if (params.id > 0) return post(baseApi + "/user/update", params);
  return post(baseApi + "/user/add", params);
}
// 用户配置 - 删除
export function userDelete(params){
  return get(baseApi + "/user/delete", params);
}